import * as React from "react";

import axios from "axios";

import { Link, useNavigate } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Accordion from "react-bootstrap/Accordion";
import {
  RiLoader4Fill,
  RiCircleLine,
  RiCheckboxCircleFill,
  RiBuilding2Line,
  RiUserLine,
  RiUserAddLine,
  RiArrowLeftLine,
  RiArrowRightLine,
  RiFileEditLine,
  RiCalculatorLine,
  RiCheckLine,
} from "react-icons/ri";

import Textfield from "../../Components/Textfield";
import Button from "../../Components/Button";
import Checkbox from "../../Components/Checkbox";
import Dropzone from "../../Components/Dropzone";
import Select from "../../Components/Select";
import CustomRadio from "../../Components/CustomRadio";

import TopBarNotConnected from "../../Components/TopBarNotConnected";

import { useToast } from "../../Context/ToastContext";
import { useLoader } from "../../Context/LoaderContext";

import Logo from "./../../Images/logo_white.png";
import bgSidebarRight from "./../../Images/bg_sidebar_right.png";
import bgSidebarMobilier from "./../../Images/bg_sidebar_mobilier.png";
import bgSidebarImmobilier from "./../../Images/bg_sidebar_immobilier.png";

import "./FinancingRequestNotConnected.scss";

const initialFormState = {
  declaration_recap: false,
  // Compnay Intial Form
  person_type: "professional",

  client_name: "",
  gerant_name: "",
  cin: "",
  object_request: "",
  matricule_fiscale: "",
  secteur_activity: "",

  email: "",
  company_phone: "",
  company_fax: "",
  code_postal: "",
  address: "",
  ville: "",

  // document Intial Form
  cin_doc: [],
  patente_doc: [],
  facture_proforma_doc: [],
  cp_doc: [],
  rne_doc: [],
  releves_doc: [],
  facture_sonede_doc: [],
  cdf_doc: [],
  permis_doc: [],
  rib_doc: [],
  attestation_agri_doc: [],
  titre_agri_doc: [],
  taxe_trans_agri_doc: [],
  status_company_doc: [],
  repartition_capital_doc: [],
  pouvoir_dg_doc: [],
  bilan_taxe_doc: [],
};

const FinancingRequestNotConnected = () => {
  const [valRegister, setValRegister] = React.useState(initialFormState);
  const [formErrorMessages, setFormErrorMessages] = React.useState("");

  const [stepFinancingRequest, setStepFinancingRequest] = React.useState(1);

  const scrollToRef = React.useRef(null);

  const navigate = useNavigate();

  const { addToast } = useToast();
  const { setIsLoading } = useLoader();

  const handleChangeField = (val, key) => {
    setFormErrorMessages((prev) => ({
      ...prev,
      [key]: "",
    }));

    setValRegister((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    const formData = new FormData();
    formData.append("person_type", valRegister.person_type);
    formData.append("client_name", valRegister.client_name);
    formData.append("gerant_name", valRegister.gerant_name);
    formData.append("cin", valRegister.cin);
    formData.append("object_request", valRegister.object_request);
    formData.append("matricule_fiscale", valRegister.matricule_fiscale);
    formData.append("secteur_activity", valRegister.secteur_activity);
    formData.append("email", valRegister.email);
    formData.append("company_fax", valRegister.company_fax);
    formData.append("company_phone", valRegister.company_phone);
    formData.append("company_address", valRegister.company_address);
    formData.append("company_ville", valRegister.company_ville);
    formData.append("company_cp", valRegister.company_cp);

    // Cas d’un professionnel
    formData.append("cin_doc", valRegister.cin_doc[0] || []);
    formData.append("patente_doc", valRegister.patente_doc[0] || []);
    formData.append(
      "facture_proforma_doc",
      valRegister.facture_proforma_doc[0] || []
    );
    formData.append("cp_doc", valRegister.cp_doc[0] || []);
    formData.append("rne_doc", valRegister.rne_doc[0] || []);
    formData.append("releves_doc", valRegister.releves_doc[0] || []);
    formData.append(
      "facture_sonede_doc",
      valRegister.facture_sonede_doc[0] || []
    );
    formData.append("cdf_doc", valRegister.cdf_doc[0] || []);
    formData.append("permis_doc", valRegister.permis_doc[0] || []);
    formData.append("rib_doc", valRegister.rib_doc[0] || []);

    // Cas d’un agriculteur
    formData.append(
      "attestation_agri_doc",
      valRegister.attestation_agri_doc[0] || []
    );
    formData.append("titre_agri_doc", valRegister.titre_agri_doc[0] || []);
    formData.append(
      "taxe_trans_agri_doc",
      valRegister.taxe_trans_agri_doc[0] || []
    );

    // Cas d’une entreprise
    formData.append(
      "status_company_doc",
      valRegister.status_company_doc[0] || []
    );
    formData.append(
      "repartition_capital_doc",
      valRegister.repartition_capital_doc[0] || []
    );
    formData.append("pouvoir_dg_doc", valRegister.pouvoir_dg_doc[0] || []);
    formData.append("bilan_taxe_doc", valRegister.bilan_taxe_doc[0] || []);

    axios
      .post(
        `${process.env.REACT_APP_API_URL}/financing-request/update`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem(
              process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE
            ),
          },
        }
      )
      .then((response) => {
        setIsLoading(false);

        if (response.data.status) {
          localStorage.removeItem(
            process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE
          );

          localStorage.removeItem("InfosSimulation");
          localStorage.removeItem("resultAmount");
          localStorage.removeItem("DataFinancingRequest");

          addToast({
            variant: "success",
            message: response.data.message,
          });
          navigate("/confirm-soumission-request");
        }
      })
      .catch((error) => {
        setIsLoading(false);

        if (error.response.data.errors) {
          setFormErrorMessages(error.response.data.errors);
        } else {
          addToast({
            variant: "danger",
            message: error.response.data.message,
          });
        }
      });
  };

  const handleNextSetp = () => {
    setStepFinancingRequest((prev) => prev + 1);
    scrollToRef.current?.scrollIntoView({ behavior: "smooth" });
    localStorage.setItem("DataFinancingRequest", JSON.stringify(valRegister));
  };

  const handlePrevSetp = () => {
    setStepFinancingRequest((prev) => prev - 1);
    scrollToRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const InfoSimulation = JSON.parse(localStorage.getItem("InfosSimulation"));
  const resultAmount = JSON.parse(localStorage.getItem("resultAmount"));
  const DataFinancingRequest = JSON.parse(
    localStorage.getItem("DataFinancingRequest")
  );

  const propertyType = InfoSimulation?.product_name || "-";

  return (
    <div className="layout-app layout-not-connected ">
      <div className="sideBar sideBar-not-connected">
        <Link to="/" className="logo logo-white">
          <img
            src={Logo}
            alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
          />
        </Link>
        <div className="title-sidebar-not-connected active">
          Lancez votre projet Leasing
        </div>
        <div className="menu-sidebar-not-connected">
          <RiCalculatorLine /> Simulations
        </div>
        <div className="menu-sidebar-not-connected active">
          <RiFileEditLine /> Demande de Financement
        </div>
      </div>
      <div className="wrap-app wrap-app-not-connected">
        <TopBarNotConnected
          backTo
          url="/simulations"
          colWidth={12}
          title={(() => {
            switch (stepFinancingRequest) {
              case 1:
                return "Informations Clients";
              case 2:
                return "Documents à Joindre";
              default:
                return "Récapitulatif";
            }
          })()}
          description={(() => {
            switch (stepFinancingRequest) {
              case 1:
                return "Fournissez les détails de votre entreprise pour identifier clairement le demandeur du financement.";
              case 2:
                return "Liste des documents nécessaires à l'analyse de votre demande de financement";
              default:
                return "Revoyez toutes les informations fournies dans ce formulaire pour vous assurer de leur exactitude et de leur exhaustivité.";
            }
          })()}
        />
        <div className="" ref={scrollToRef}></div>

        <div className="container-app container-app-not-connected">
          <div className="wrap-steps-sidebar-not-connected">
            <div
              className={`steps-sidebar-not-connected ${
                stepFinancingRequest === 1 ? "active" : ""
              } ${stepFinancingRequest > 1 ? "visited" : ""}`}
            >
              1. Informations Clients
              {stepFinancingRequest > 1 ? <RiCheckLine /> : ""}
            </div>

            <div
              className={`steps-sidebar-not-connected ${
                stepFinancingRequest === 2 ? "active" : ""
              } ${stepFinancingRequest > 2 ? "visited" : ""}`}
            >
              2. Documents à Joindre
              {stepFinancingRequest > 2 ? <RiCheckLine /> : ""}
            </div>
            <div
              className={`steps-sidebar-not-connected ${
                stepFinancingRequest === 3 ? "active" : ""
              } `}
            >
              3. Récapitulatif
              {stepFinancingRequest > 3 ? <RiCheckLine /> : ""}
            </div>
          </div>
          <Row>
            <Col md={stepFinancingRequest < 3 ? 8 : 12}>
              <div className="wrap-financing-request">
                <form
                  className="financing-request"
                  onSubmit={handleSubmit}
                  noValidate
                >
                  {stepFinancingRequest === 1 && (
                    <div className="step-financing-request">
                      <label
                        htmlFor="product_name"
                        className="bold d-block mb-2"
                      >
                        Choisir type de client
                      </label>
                      <div
                        className={` mb-2 wrap-radios ${
                          formErrorMessages.product_name ? "error-radio" : ""
                        }`}
                      >
                        <CustomRadio
                          label="Professionnel"
                          id="professional"
                          className="bg_white"
                          icone={<RiUserLine />}
                          name="person_type"
                          value="professional"
                          onChange={(e) => {
                            if (e.target.checked)
                              handleChangeField(e.target.value, "person_type");
                          }}
                          checked={valRegister.person_type === "professional"}
                        />
                        <CustomRadio
                          label="Agriculteur"
                          id="farmer"
                          className="bg_white"
                          icone={<RiUserAddLine />}
                          name="person_type"
                          value="farmer"
                          onChange={(e) => {
                            if (e.target.checked)
                              handleChangeField(e.target.value, "person_type");
                          }}
                          checked={valRegister.person_type === "farmer"}
                        />

                        <CustomRadio
                          label="Entreprise"
                          id="company"
                          className="bg_white"
                          icone={<RiBuilding2Line />}
                          name="person_type"
                          value="company"
                          onChange={(e) => {
                            if (e.target.checked)
                              handleChangeField(e.target.value, "person_type");
                          }}
                          checked={valRegister.person_type === "company"}
                        />
                        {formErrorMessages.person_type && (
                          <div className="text-danger">
                            {formErrorMessages.person_type}
                          </div>
                        )}
                      </div>
                      <h2 className="title_form">Identité de la société</h2>
                      <Textfield
                        label="Nom du client"
                        name="client_name"
                        required
                        type="text"
                        placeholder="Veuillez insérer votre nom du client"
                        size="large"
                        value={valRegister.client_name}
                        onChange={(e) =>
                          handleChangeField(e.target.value, "client_name")
                        }
                        hasError={formErrorMessages.client_name}
                        errorMessage={
                          formErrorMessages.client_name && (
                            <div className="text-danger">
                              {formErrorMessages.client_name}
                            </div>
                          )
                        }
                      />
                      {valRegister.person_type === "company" && (
                        <Textfield
                          label="Nom du gérant"
                          name="gerant_name"
                          required
                          type="text"
                          placeholder="Veuillez insérer votre nom du gérant"
                          size="large"
                          value={valRegister.gerant_name}
                          onChange={(e) =>
                            handleChangeField(e.target.value, "gerant_name")
                          }
                          hasError={formErrorMessages.gerant_name}
                          errorMessage={
                            formErrorMessages.gerant_name && (
                              <div className="text-danger">
                                {formErrorMessages.gerant_name}
                              </div>
                            )
                          }
                        />
                      )}
                      <Textfield
                        label={
                          valRegister.person_type === "company"
                            ? "CIN du gérant"
                            : "CIN"
                        }
                        name="cin"
                        required
                        type="text"
                        placeholder={
                          valRegister.person_type === "company"
                            ? "Veuillez insérer votre CIN du gérant"
                            : "Veuillez insérer votre CIN"
                        }
                        size="large"
                        value={valRegister.cin}
                        onChange={(e) =>
                          handleChangeField(e.target.value, "cin")
                        }
                        hasError={formErrorMessages.cin}
                        errorMessage={
                          formErrorMessages.cin && (
                            <div className="text-danger">
                              {formErrorMessages.cin}
                            </div>
                          )
                        }
                      />
                      <Textfield
                        label="Objet de la demande"
                        name="object_request"
                        required
                        type="text"
                        placeholder="Veuillez insérer votre objet de la demande"
                        size="large"
                        value={valRegister.object_request}
                        onChange={(e) =>
                          handleChangeField(e.target.value, "object_request")
                        }
                        hasError={formErrorMessages.object_request}
                        errorMessage={
                          formErrorMessages.object_request && (
                            <div className="text-danger">
                              {formErrorMessages.object_request}
                            </div>
                          )
                        }
                      />
                      <Textfield
                        label="Matricule Fiscale"
                        name="matricule_fiscale"
                        required={
                          valRegister.person_type === "professional" ||
                          valRegister.person_type === "company"
                        }
                        type="text"
                        placeholder="Veuillez insérer votre matricule fiscale"
                        size="large"
                        value={valRegister.matricule_fiscale}
                        onChange={(e) =>
                          handleChangeField(e.target.value, "matricule_fiscale")
                        }
                        hasError={formErrorMessages.matricule_fiscale}
                        errorMessage={
                          formErrorMessages.matricule_fiscale && (
                            <div className="text-danger">
                              {formErrorMessages.matricule_fiscale}
                            </div>
                          )
                        }
                      />

                      <Select
                        label="Secteur d'Activité"
                        id="secteur_activity"
                        required
                        value={valRegister.secteur_activity || ""}
                        onChange={(e) =>
                          handleChangeField(e.target.value, "secteur_activity")
                        }
                        hasError={formErrorMessages.secteur_activity}
                        errorMessage={
                          <div className="text-danger">
                            {formErrorMessages.secteur_activity}
                          </div>
                        }
                      >
                        <option value="">--</option>
                        <option value="1">Commerce de gros</option>
                        <option value="2">Commerce de gros</option>
                      </Select>
                      <h2 className="title_form mt-40">
                        Coordonnés de l’entreprise
                      </h2>
                      <Textfield
                        label="Email"
                        name="email"
                        required={
                          valRegister.person_type === "professional" ||
                          valRegister.person_type === "company"
                        }
                        type="text"
                        placeholder="Veuillez insérer votre email"
                        size="large"
                        value={valRegister.email}
                        onChange={(e) =>
                          handleChangeField(e.target.value, "email")
                        }
                        hasError={formErrorMessages.email}
                        errorMessage={
                          formErrorMessages.email && (
                            <div className="text-danger">
                              {formErrorMessages.email}
                            </div>
                          )
                        }
                      />
                      <Row>
                        <Col md={6}>
                          <Textfield
                            label="Téléphone"
                            name="company_phone"
                            required
                            type="text"
                            placeholder="Veuillez insérer votre téléphone"
                            size="large"
                            value={valRegister.company_phone}
                            onChange={(e) =>
                              handleChangeField(e.target.value, "company_phone")
                            }
                            hasError={formErrorMessages.company_phone}
                            errorMessage={
                              formErrorMessages.company_phone && (
                                <div className="text-danger">
                                  {formErrorMessages.company_phone}
                                </div>
                              )
                            }
                          />
                        </Col>
                        <Col md={6}>
                          <Textfield
                            label="Fax"
                            name="company_fax"
                            type="text"
                            placeholder="Veuillez insérer votre fax"
                            size="large"
                            value={valRegister.company_fax}
                            onChange={(e) =>
                              handleChangeField(e.target.value, "company_fax")
                            }
                            hasError={formErrorMessages.company_fax}
                            errorMessage={
                              formErrorMessages.company_fax && (
                                <div className="text-danger">
                                  {formErrorMessages.company_fax}
                                </div>
                              )
                            }
                          />
                        </Col>
                      </Row>
                      <Textfield
                        label="Adresse"
                        name="company_address"
                        required
                        type="text"
                        placeholder="Veuillez insérer votre adresse"
                        size="large"
                        value={valRegister.company_address}
                        onChange={(e) =>
                          handleChangeField(e.target.value, "company_address")
                        }
                        hasError={formErrorMessages.company_address}
                        errorMessage={
                          formErrorMessages.company_address && (
                            <div className="text-danger">
                              {formErrorMessages.company_address}
                            </div>
                          )
                        }
                      />
                      <Textfield
                        label="Ville"
                        name="company_ville"
                        required
                        type="text"
                        placeholder="Veuillez insérer votre ville"
                        size="large"
                        value={valRegister.company_ville}
                        onChange={(e) =>
                          handleChangeField(e.target.value, "company_ville")
                        }
                        hasError={formErrorMessages.company_ville}
                        errorMessage={
                          formErrorMessages.company_ville && (
                            <div className="text-danger">
                              {formErrorMessages.company_ville}
                            </div>
                          )
                        }
                      />
                      <Textfield
                        label="Code postal"
                        name="company_cp"
                        required
                        type="text"
                        placeholder="Veuillez insérer votre code postal"
                        size="large"
                        value={valRegister.company_cp}
                        onChange={(e) =>
                          handleChangeField(e.target.value, "company_cp")
                        }
                        hasError={formErrorMessages.company_cp}
                        errorMessage={
                          formErrorMessages.company_cp && (
                            <div className="text-danger">
                              {formErrorMessages.company_cp}
                            </div>
                          )
                        }
                      />
                    </div>
                  )}

                  {stepFinancingRequest === 2 && (
                    <div className="step-financing-request">
                      {valRegister.person_type === "farmer" && (
                        <Dropzone
                          label="Attestation d'agriculture UTAP ou SYNAGRI"
                          name="attestation_agri_doc"
                          hasError={formErrorMessages.attestation_agri_doc}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.attestation_agri_doc}
                            </div>
                          }
                          value={valRegister.attestation_agri_doc || []}
                          onChange={(files) =>
                            handleChangeField(files, "attestation_agri_doc")
                          }
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      )}

                      <Dropzone
                        label={
                          valRegister.person_type === "company"
                            ? "CIN du gérant, des associés pour les SARL"
                            : "CIN"
                        }
                        name="cin_doc"
                        hasError={formErrorMessages.cin_doc}
                        errorMessage={
                          <div className="text-danger">
                            {formErrorMessages.cin_doc}
                          </div>
                        }
                        value={valRegister.cin_doc || []}
                        onChange={(files) =>
                          handleChangeField(files, "cin_doc")
                        }
                        required
                        multiple
                        accept="image/*,.pdf"
                        description={
                          <>
                            Cette dropzone accepte les fichiers de type
                            <b> png, jpg, jpeg, pdf</b>
                          </>
                        }
                      />
                      {valRegister.person_type === "farmer" && (
                        <Dropzone
                          label="Titre de propriété agricole"
                          name="titre_agri_doc"
                          hasError={formErrorMessages.titre_agri_doc}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.titre_agri_doc}
                            </div>
                          }
                          value={valRegister.titre_agri_doc || []}
                          onChange={(files) =>
                            handleChangeField(files, "titre_agri_doc")
                          }
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      )}
                      {valRegister.person_type !== "farmer" && (
                        <Dropzone
                          label="Patente"
                          name="patente_doc"
                          hasError={formErrorMessages.patente_doc}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.patente_doc}
                            </div>
                          }
                          value={valRegister.patente_doc || []}
                          onChange={(files) =>
                            handleChangeField(files, "patente_doc")
                          }
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      )}
                      <Dropzone
                        label="Facture PROFORMA"
                        name="facture_proforma_doc"
                        hasError={formErrorMessages.facture_proforma_doc}
                        errorMessage={
                          <div className="text-danger">
                            {formErrorMessages.facture_proforma_doc}
                          </div>
                        }
                        value={valRegister.facture_proforma_doc || []}
                        onChange={(files) =>
                          handleChangeField(files, "facture_proforma_doc")
                        }
                        required
                        accept="image/*,.pdf"
                        description={
                          <>
                            Cette dropzone accepte les fichiers de type
                            <b> png, jpg, jpeg, pdf</b>
                          </>
                        }
                      />
                      {valRegister.person_type === "company" && (
                        <>
                          <Dropzone
                            label="Statuts à jour et Procès-verbal (Si modifications statutaires)"
                            name="status_company_doc"
                            hasError={formErrorMessages.status_company_doc}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.status_company_doc}
                              </div>
                            }
                            value={valRegister.status_company_doc || []}
                            onChange={(files) =>
                              handleChangeField(files, "status_company_doc")
                            }
                            required
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                          <Dropzone
                            label="Répartition du Capital (pour SA)"
                            name="repartition_capital_doc"
                            hasError={formErrorMessages.repartition_capital_doc}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.repartition_capital_doc}
                              </div>
                            }
                            value={valRegister.repartition_capital_doc || []}
                            onChange={(files) =>
                              handleChangeField(
                                files,
                                "repartition_capital_doc"
                              )
                            }
                            required
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                          <Dropzone
                            label="Pouvoirs du/des Gérants ou DG ou PDG (pour SA)"
                            name="pouvoir_dg_doc"
                            hasError={formErrorMessages.pouvoir_dg_doc}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.pouvoir_dg_doc}
                              </div>
                            }
                            value={valRegister.pouvoir_dg_doc || []}
                            onChange={(files) =>
                              handleChangeField(files, "pouvoir_dg_doc")
                            }
                            required
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}
                      {valRegister.person_type === "professional" && (
                        <Dropzone
                          label="Carte Professionnelle (pour les professions libérales)"
                          name="cp_doc"
                          hasError={formErrorMessages.cp_doc}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.cp_doc}
                            </div>
                          }
                          value={valRegister.cp_doc || []}
                          onChange={(files) =>
                            handleChangeField(files, "cp_doc")
                          }
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      )}
                      {valRegister.person_type !== "farmer" && (
                        <Dropzone
                          label="Registre National des Entreprises (datant de moins de 03mois)"
                          name="rne_doc"
                          hasError={formErrorMessages.rne_doc}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.rne_doc}
                            </div>
                          }
                          value={valRegister.rne_doc || []}
                          onChange={(files) =>
                            handleChangeField(files, "rne_doc")
                          }
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      )}

                      <Dropzone
                        label={
                          valRegister.person_type === "farmer"
                            ? "Relevés bancaires des 06 derniers mois (Courant / Epargne)"
                            : "Relevés bancaires des 03 derniers mois"
                        }
                        name="releves_doc"
                        hasError={formErrorMessages.releves_doc}
                        errorMessage={
                          <div className="text-danger">
                            {formErrorMessages.releves_doc}
                          </div>
                        }
                        value={valRegister.releves_doc || []}
                        onChange={(files) =>
                          handleChangeField(files, "releves_doc")
                        }
                        required
                        multiple
                        accept="image/*,.pdf"
                        description={
                          <>
                            Cette dropzone accepte les fichiers de type
                            <b> png, jpg, jpeg, pdf</b>
                          </>
                        }
                      />
                      {valRegister.person_type === "company" && (
                        <Dropzone
                          label="Bilans et Comptes Annexes des 3 derniers exercices (Rapports CAC pour les SA)"
                          name="bilan_taxe_doc"
                          hasError={formErrorMessages.bilan_taxe_doc}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.bilan_taxe_doc}
                            </div>
                          }
                          value={valRegister.bilan_taxe_doc || []}
                          onChange={(files) =>
                            handleChangeField(files, "bilan_taxe_doc")
                          }
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      )}
                      {valRegister.person_type === "farmer" && (
                        <Dropzone
                          label="Taxe de transport agricole ou carte grise de matériel agricole (Si pas de relevés bancaires)"
                          name="taxe_trans_agri_doc"
                          hasError={formErrorMessages.taxe_trans_agri_doc}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.taxe_trans_agri_doc}
                            </div>
                          }
                          value={valRegister.taxe_trans_agri_doc || []}
                          onChange={(files) =>
                            handleChangeField(files, "taxe_trans_agri_doc")
                          }
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      )}
                      {valRegister.person_type !== "company" && (
                        <Dropzone
                          label="Facture SONEDE/STEG"
                          name="facture_sonede_doc"
                          hasError={formErrorMessages.facture_sonede_doc}
                          errorMessage={
                            <div className="text-danger">
                              {formErrorMessages.facture_sonede_doc}
                            </div>
                          }
                          value={valRegister.facture_sonede_doc || []}
                          onChange={(files) =>
                            handleChangeField(files, "facture_sonede_doc")
                          }
                          required
                          accept="image/*,.pdf"
                          description={
                            <>
                              Cette dropzone accepte les fichiers de type
                              <b> png, jpg, jpeg, pdf</b>
                            </>
                          }
                        />
                      )}
                      {valRegister.person_type === "professional" && (
                        <>
                          <Dropzone
                            label="Certificat de dégrèvement fiscal (pour les Taxis / Louages)"
                            name="cdf_doc"
                            hasError={formErrorMessages.cdf_doc}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.cdf_doc}
                              </div>
                            }
                            value={valRegister.cdf_doc || []}
                            onChange={(files) =>
                              handleChangeField(files, "cdf_doc")
                            }
                            required
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                          <Dropzone
                            label="Permis de Conduire (pour les Taxis/Louages)"
                            name="permis_doc"
                            hasError={formErrorMessages.permis_doc}
                            errorMessage={
                              <div className="text-danger">
                                {formErrorMessages.permis_doc}
                              </div>
                            }
                            value={valRegister.permis_doc || []}
                            onChange={(files) =>
                              handleChangeField(files, "permis_doc")
                            }
                            required
                            accept="image/*,.pdf"
                            description={
                              <>
                                Cette dropzone accepte les fichiers de type
                                <b> png, jpg, jpeg, pdf</b>
                              </>
                            }
                          />
                        </>
                      )}

                      <Dropzone
                        label="RIB"
                        name="rib_doc"
                        hasError={formErrorMessages.rib_doc}
                        errorMessage={
                          <div className="text-danger">
                            {formErrorMessages.rib_doc}
                          </div>
                        }
                        value={valRegister.rib_doc || []}
                        onChange={(files) =>
                          handleChangeField(files, "rib_doc")
                        }
                        required
                        accept="image/*,.pdf"
                        description={
                          <>
                            Cette dropzone accepte les fichiers de type
                            <b> png, jpg, jpeg, pdf</b>
                          </>
                        }
                      />
                    </div>
                  )}
                  {stepFinancingRequest === 3 && (
                    <div className="step-financing-request custom-accordion mb-16">
                      <Accordion defaultActiveKey="0" alwaysOpen>
                        <Accordion.Item eventKey="0">
                          <Accordion.Header>
                            Détails du Projet de Leasing
                          </Accordion.Header>
                          <Accordion.Body>
                            <table className="table custom-table">
                              <tbody>
                                <tr>
                                  <td>Montant</td>
                                  <td>{InfoSimulation?.amount || "-"} TND</td>
                                </tr>
                                <tr>
                                  <td>Autofinancement</td>
                                  <td>
                                    {InfoSimulation?.self_financing || "-"} TND
                                  </td>
                                </tr>
                                <tr>
                                  <td>Durée</td>
                                  <td className="orange">
                                    {InfoSimulation?.duration || "-"} mois
                                  </td>
                                </tr>
                                <tr>
                                  <td>Taux</td>
                                  <td>{InfoSimulation?.taux || "-"} %</td>
                                </tr>
                                {/* <tr>
                                  <td>Marque</td>
                                  <td>Audi</td>
                                </tr> */}
                                <tr>
                                  <td>Type de bien à financer</td>
                                  <td className="text-capitalize">
                                    {propertyType}
                                  </td>
                                </tr>
                                {/* <tr>
                                  <td>Fournisseur</td>
                                  <td>Ennakl</td>
                                </tr> */}
                                <tr>
                                  <td>Description</td>
                                  <td>{InfoSimulation?.description || "-"}</td>
                                </tr>

                                <tr>
                                  <td colSpan={2} className="last-child-table">
                                    <div className="titlte-montant">
                                      Montant du loyer par mois
                                    </div>
                                    <div className="value-montant">
                                      {resultAmount || "-"} TND
                                    </div>
                                    <p>Le taux appliqué au niveau du site est à titre indicatif</p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                          <Accordion.Header>
                            Informations sur le Demandeur
                          </Accordion.Header>
                          <Accordion.Body>
                            <table className="table custom-table">
                              <tbody>
                                <tr>
                                  <td>Nom</td>
                                  <td>
                                    {DataFinancingRequest.first_name || "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Matricule fiscal</td>
                                  <td>
                                    {DataFinancingRequest.matricule_fiscale ||
                                      "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Date de création</td>
                                  <td>
                                    {DataFinancingRequest.company_fax || "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Secteur d'Activité</td>
                                  <td>
                                    {DataFinancingRequest.secteur_activity ||
                                      "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Email de l'Entreprise</td>
                                  <td>
                                    {DataFinancingRequest.company_mail || "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Téléphone</td>
                                  <td>
                                    {DataFinancingRequest.company_phone || "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Portable</td>
                                  <td>
                                    {DataFinancingRequest.company_fax || "-"}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Adresse</td>
                                  <td>
                                    {DataFinancingRequest.company_address ||
                                      "-"}
                                    <br />
                                    {DataFinancingRequest.company_ville || "-"}
                                    {""}
                                    {DataFinancingRequest.company_cp || "-"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                          <Accordion.Header>
                            Documents à Joindre
                          </Accordion.Header>
                          <Accordion.Body>
                            <ul className="list-accordion">
                              <li>
                                Bilans et Comptes de Résultat des 3 Dernières
                                Années.pdf
                              </li>
                              <li> Prévisions Financières.pdf</li>
                              <li>Extrait Kbis de Moins de 3 Mois.pdf</li>
                              <li>
                                Pièce d'Identité du Représentant Légal.pdf
                              </li>
                              <li>
                                Relevés de Compte Bancaire des 6 Derniers
                                Mois.pdf
                              </li>
                              <li>
                                Devis ou Facture Proforma du FournisseurPDF
                              </li>
                              {/* <li>
                                {DataFinancingRequest.cin_doc || "-"}
                              </li>
                              <li>
                                {DataFinancingRequest.patente_doc ||
                                  "-"}
                              </li>
                              <li>
                                {DataFinancingRequest.extrait_kbis || "-"}
                              </li>
                              <li>{DataFinancingRequest.piece_legal || "-"}</li>
                              <li>
                                {DataFinancingRequest.releves_comptes || "-"}
                              </li>
                              <li>
                                {DataFinancingRequest.facture_fournisseur ||
                                  "-"}
                              </li> */}
                            </ul>
                          </Accordion.Body>
                        </Accordion.Item>
                      </Accordion>

                      <h2 className="title_form mt-40">Déclaration</h2>
                      <Checkbox
                        label="Je soussigné(e) Tarek MESLAMENI, représentant légal de Medianet, certifie que les informations fournies dans ce formulaire sont exactes et complètes.
                              Je m'engage à informer immédiatement l'institution financière de toute modification concernant les informations fournies."
                        id="declaration_recap"
                        name="declaration_recap"
                        value="declaration_recap"
                        onChange={(e) =>
                          handleChangeField(
                            e.target.checked,
                            "declaration_recap"
                          )
                        }
                        // checked={
                        //   valRegister.declaration_recap === "declaration_recap"
                        // }
                      />
                    </div>
                  )}

                  <div className="wrap-btn-action-request">
                    {stepFinancingRequest > 1 && (
                      <Button
                        variant="white"
                        onClick={handlePrevSetp}
                        disabled={stepFinancingRequest <= 1}
                      >
                        <RiArrowLeftLine />
                        Précedent
                      </Button>
                    )}
                    {stepFinancingRequest < 3 && (
                      <Button
                        onClick={handleNextSetp}
                        disabled={stepFinancingRequest >= 3}
                      >
                        Suivant <RiArrowRightLine />
                      </Button>
                    )}
                    {stepFinancingRequest === 3 && (
                      <Button
                        type="submit"
                        disabled={!valRegister.declaration_recap}
                      >
                        Soumettre la Demande
                      </Button>
                    )}
                  </div>
                </form>
              </div>
            </Col>
            {stepFinancingRequest < 3 && (
              <Col md={4}>
                <div className="wrap-sidebar-right">
                  <div className="header-sidebar-right-notConnected">
                    <img
                      src={
                        propertyType === "immobilier"
                          ? bgSidebarImmobilier
                          : propertyType === "mobilier"
                          ? bgSidebarMobilier
                          : bgSidebarRight
                      }
                      alt=""
                      style={{ maxWidth: "100%", width: "100%" }}
                    />
                  </div>
                  <div className="content-sidebar-right-notConnected">
                    <div className="title-content-sidebar-right">
                      Résultat de la simulation
                    </div>
                    <div className="box-content-sidebar-right">
                      <div className="subtitle-content-sidebar-right">
                        Montant du loyer par mois
                      </div>
                      <div className="txt-content-sidebar-right price-sidebar">
                        {resultAmount || "-"} TND
                      </div>
                      <p>Le taux appliqué au niveau du site est  à titre indicatif</p>
                    </div>
                    <div className="box-content-sidebar-right">
                      <div className="subtitle-content-sidebar-right">
                        Type de bien à financer
                      </div>
                      <div className="txt-content-sidebar-right text-capitalize">
                        {propertyType}
                      </div>
                    </div>
                    <div className="box-content-sidebar-right">
                      <div className="subtitle-content-sidebar-right">
                        Montant
                      </div>
                      <div className="txt-content-sidebar-right">
                        {InfoSimulation?.amount || "-"} TND
                      </div>
                    </div>
                    <div className="box-content-sidebar-right">
                      <div className="subtitle-content-sidebar-right">
                        Autofinancement
                      </div>
                      <div className="txt-content-sidebar-right">
                        {InfoSimulation?.self_financing || "-"} TND
                      </div>
                    </div>
                    <div className="box-content-sidebar-right">
                      <div className="subtitle-content-sidebar-right">
                        Durée
                      </div>
                      <div className="txt-content-sidebar-right">
                        {InfoSimulation?.duration || "-"} Mois
                      </div>
                    </div>
                  </div>
                  <div className="footer-sidebar-right-notConnected">
                    Assurez-vous de remplir chaque champ avec précision pour
                    éviter tout retard dans le traitement de votre demande.
                  </div>
                </div>
              </Col>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default FinancingRequestNotConnected;
